// import { createRouter, createWebHistory } from "vue-router";
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  // 首页
  {
    path: "/",
    name: "index",
    component: () => import("../views/home/home.vue"),
  },
  // 404
  { path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("../views/error/404.vue") },
  // 文章列表
  {
    path: "/list",
    name: "/list",
    component: () => import("../views/list/index.vue"),
  },
  // 文章详情
  {
    path: "/Articledetails",
    name: "/Articledetails",
    component: () => import("../views/Articledetails/index.vue"),
  },
  // 查询通知书
  {
    path: "/CheckNotice",
    name: "/CheckNotice",
    component: () => import("../views/CheckNotice/index.vue"),
  },
  // 查询成绩
  {
    path: "/CheckScore",
    name: "/CheckScore",
    component: () => import("../views/CheckScore/index.vue"),
  },
  // 查询录取
  {
    path: "/CheckEnroll",
    name: "/CheckEnroll",
    component: () => import("../views/CheckEnroll/index.vue"),
  },
  // 查询准考证
  {
    path: "/CheckTicket",
    name: "/CheckTicket",
    component: () => import("../views/CheckTicket/index.vue"),
  },
  // 招生简章
  {
    path: "/AdmissionLetter",
    name: "/AdmissionLetter",
    component: () => import("../views/AdmissionLetter/index.vue"),
  },
  {
    path: "/SignUp",
    name: "/SignUp",
    component: () => import("../views/SignUp/index.vue"),
  },
  {
    path: "/Q&A",
    name: "/Q&A",
    component: () => import("../views/Q&A/index.vue"),
  },
  {
    path: "/introduction",
    name: "/introduction",
    component: () => import("../views/introduction/index.vue"),
  },
  {
    path: "/zfHome",
    name: "/zfHome",
    component: () => import("../views/zfHome/index.vue"),
  },
  {
    path: "/login",
    name: "/login",
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/password",
    name: "/password",
    component: () => import("../views/password/index.vue"),
  },
  {
    path: "/Signin",
    name: "/Signin",
    component: () => import("../views/Signin/index.vue"),
  },
  {
    path: "/studentIndex",
    name: "/studentIndex",
    meta: { requiresAuth: true }, //是否需要登录验证
    component: () => import("../views/studentIndex/index.vue"),
  },
  {
    path: "/BasicInformation",
    name: "/BasicInformation",
    meta: { requiresAuth: true },
    component: () => import("../views/BasicInformation/index.vue"),
  },
  {
    path: "/voluntary",
    name: "/voluntary",
    meta: { requiresAuth: true },
    component: () => import("../views/voluntary/index.vue"),
  },
  {
    path: "/voluntaryTow",
    name: "/voluntaryTow",
    meta: { requiresAuth: true },
    component: () => import("../views/voluntaryTow/index.vue"),
  },
  {
    path: "/material",
    name: "/material",
    // meta: { requiresAuth: true },
    component: () => import("../views/material/index.vue"),
  },
  {
    path: "/tongzhishu",
    name: "/tongzhishu",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/tongzhishu/tongzhishu.vue"),
  },
  {
    path: "/grade1",
    name: "/grade1",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/grade/grade1.vue"),
  },
  {
    path: "/enroll1",
    name: "/enroll1",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/enroll/enroll1.vue"),
  },
  {
    path: "/enroll2",
    name: "/enroll2",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/enroll/enroll2.vue"),
  },
  {
    path: "/ticket1",
    name: "/ticket1",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/ticket/ticket1.vue"),
  },
  {
    path: "/ticket2",
    name: "/ticket2",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/ticket/ticket2.vue"),
  },
  {
    path: "/ticket3",
    name: "/ticket3",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/ticket/ticket3.vue"),
  },
  {
    path: "/ticket4",
    name: "/ticket4",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/ticket/ticket4.vue"),
  },
  {
    path: "/notice1",
    name: "/notice1",
    // meta: { requiresAuth: true },
    component: () => import("../views/disposition/notice/notice1.vue"),
  },
  {
    path: "/zfbPay",
    name: "/zfbPay",
    meta: { requiresAuth: true },
    component: () => import("../views/zfbPay/index.vue"),
  },
  {
    path: "/studentCheckGrade",
    name: "/studentCheckGrade",
    meta: { requiresAuth: true },
    component: () => import("../views/studentCheckGrade/index.vue"),
  },
  {
    path: "/studentCheckTicket",
    name: "/studentCheckTicket",
    meta: { requiresAuth: true },
    component: () => import("../views/studentCheckTicket/index.vue"),
  },
  {
    path: "/studentCheckScore",
    name: "/studentCheckScore",
    meta: { requiresAuth: true },
    component: () => import("../views/studentCheckScore/index.vue"),
  },
  {
    path: "/studentCheckNotice",
    name: "/studentCheckNotice",
    meta: { requiresAuth: true },
    component: () => import("../views/studentCheckNotice/index.vue"),
  },
  {
    path: "/studentGrade1",
    name: "/studentGrade1",
    meta: { requiresAuth: true },
    component: () => import("../views/studentDisposition/grade/grade1.vue"),
  },
  {
    path: "/studentEnroll1",
    name: "/studentEnroll1",
    meta: { requiresAuth: true },
    component: () => import("../views/studentDisposition/enroll/enroll1.vue"),
  },
  {
    path: "/studentTicket1",
    name: "/studentTicket1",
    meta: { requiresAuth: true },
    component: () => import("../views/studentDisposition/ticket/ticket1.vue"),
  },
  {
    path: "/studentTicket2",
    name: "/studentTicket2",
    meta: { requiresAuth: true },
    component: () => import("../views/studentDisposition/ticket/ticket2.vue"),
  },
  {
    path: "/studentTicket3",
    name: "/studentTicket3",
    meta: { requiresAuth: true },
    component: () => import("../views/studentDisposition/ticket/ticket3.vue"),
  },
  {
    path: "/studentTicket4",
    name: "/studentTicket4",
    meta: { requiresAuth: true },
    component: () => import("../views/studentDisposition/ticket/ticket4.vue"),
  },
  {
    path: "/studentNotice1",
    name: "/studentNotice1",
    meta: { requiresAuth: true },
    component: () => import("../views/studentDisposition/notice/notice1.vue"),
  },
  {
    path: "/voluntaryHelp",
    name: "/voluntaryHelp",
    meta: { requiresAuth: true },
    component: () => import("../views/voluntaryHelp/index.vue"),
  },
  {
    path: "/SignUpHelp",
    name: "/SignUpHelp",
    meta: { requiresAuth: true },
    component: () => import("../views/SignUpHelp/index.vue"),
  },
  {
    path: "/zfIndex",
    name: "/zfIndex",
    component: () => import("../views/zfIndex/index.vue"),
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  // mode: "hash",
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token');
  // 判断当前路由是否需要登录权限 && 是否已经登录
  if (to.meta.requiresAuth && !token) {
    next('/login'); // 重定向到登录页面
  } else {
    next(); // 继续导航
  }
});

export default router;
